import React from "react";

export default function SuccessModal({ show, onClose, title = "Success", message }) {
  if (!show) return null;

  return (
    <div className="modal fade show d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header bg-success">
            <h4 className="modal-title text-white">{title}</h4>
            <button type="button" className="btn-close btn-close-white" onClick={onClose} aria-label="Close"></button>
          </div>
          <div className="modal-body">
            {message || "Operation completed successfully."}
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-success" onClick={onClose}>
              OK
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

